import { render, staticRenderFns } from "./ShopIcon.vue?vue&type=template&id=557380a8&scoped=true&"
import script from "./ShopIcon.vue?vue&type=script&lang=js&"
export * from "./ShopIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShopIcon.vue?vue&type=style&index=0&id=557380a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557380a8",
  null
  
)

export default component.exports